<template>
  <div id="app">
    <div v-on:click="handleSignout" style="opacity: .5">Signout</div>
    <router-view></router-view>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  data() {
    return {
      isAddingProject: false
    };
  },
  methods: {
    handleSignout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push("login");
        })
        .catch(function(error) {
          // An error happened.
          console.log("sign out failed: ", error);
        });
    },
    toggleAddingProject() {
      this.isAddingProject = !this.isAddingProject;
    }
  }
};
</script>

<style>
</style>
